// Os opcionais contratados de uma assinatura, em etiquetas, a partir do estado de `useOpcionaisContratados`.
export default function OpcionaisContratados({estado}) {
    let conteudo;
    if (!estado) conteudo = <span className="bf-pill bf-pill--muted">Carregando...</span>;
    else if (estado.error) conteudo = <span className="bf-muted" style={{fontSize: 12}}>{estado.error}</span>;
    else if (!estado.items.length) conteudo = <span className="bf-pill bf-pill--muted">Nenhum opcional contratado</span>;
    else {
        conteudo = estado.items.map((item) => (
            <span key={item.moduleId} className="bf-pill bf-pill--accent">{item.leavesOn ? `${item.name} · sai em ${item.leavesOn}` : item.name}</span>
        ));
    }
    return <div className="bf-stack-1">{conteudo}</div>;
}
